<!--虾皮发货地址-->
<template>
  <el-form ref="form" :model="form" label-width="80px" size="mini">
    <div class="row-wrap">
      <h3 style="padding-left:15px; ">虾皮宅配和黑猫发货匹配地址</h3>
      <el-row v-for="(volumn, idx) in form.shipAddress" :key="idx">
        <el-col :xs="24" :sm="12" :md="18" style="padding:15px;">
          <el-form-item :label="msg('地址：')">
            <el-input v-model="volumn.xvalue" :placeholder="msg('地址必须和虾皮店铺预设的地址保持一致')"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </div>
    <div style="text-align:center; margin-top: 15px; margin-bottom:15px;">
      <el-button type="primary" size="mini" @click="update"><i class="el-icon-check"></i><span>{{ msg('确定') }}</span>
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: "UserSettingShippingAddress",
  data() {
    return {
      xgroup: 'XIAPI_ADDRESS',  //虾皮宅配和黑猫地址设置
      form: {
        shipAddress: [],
      }
    }
  },
  mounted() {
    this.getSettings();
  },
  methods: {
    getSettings() {
      var _this = this;
      this.$axios.get(this.$kit.api.user.settingList + "?xgroup=" + this.xgroup)
          .then((result) => {
            if (result.status) {
              this.buildViewData(result.data); //构建设置对象
            }
          });
    },
    buildViewData(data) {
      var _this = this;
      _this.form.shipAddress = [];
      let address = data;

      //相同的xkey，表示同一个设置
      if (address.length > 0) {
        address.forEach(a => {
          if (a.xvalue) {
            let addset = {
              id: a.id,
              xvalue: a.xvalue,
              owner: a.owner
            }
            _this.form.shipAddress.push(addset);
          }
        })
      } else {
        let def = {
          id: null,
          owner: null,
          xvalue: ""
        }
        _this.form.shipAddress.push(def);
      }
    },
    update() {
      let datas = [];
      for(let i=0; i<this.form.shipAddress.length; i++){
        let addr = this.form.shipAddress[i];
        let key = this.xgroup;
        datas.push({
          id: addr.id,
          xkey: key,
          owner: addr.owner?addr.owner:null,
          xgroup: this.xgroup,
          xvalue: addr.xvalue.trim(),
          xtype:1
        });
      }

      var _this = this;
      _this.$axios.post(_this.$kit.api.user.settingUpdate + "?xgroup=" + this.xgroup, datas).then((result) => {
        _this.$message(result.msg)
      });
    }
  }
}
</script>

<style scoped>

</style>